module.exports = __webpack_public_path__ + "images/emoji/eyes.d9090a623c5f16a1ff06.png";